var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSphtx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00B098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 6.96994V6.76969H8.10956V6.96994H3.375ZM3.375 6.38775V6.1875H8.10956V6.38775H3.375ZM5.37188 12.3728V7.37044H5.562V12.3728H5.37188ZM5.92312 12.3728V7.37044H6.11269V12.3728H5.92312ZM14.4911 11.9632L12.3548 9.70594L12.4886 9.56475L14.625 11.8215L14.4911 11.9632ZM9.29194 6.1875L11.4283 8.44481L11.2944 8.586L9.15806 6.32925L9.29194 6.1875ZM14.1013 12.375L11.9649 10.1177L12.0988 9.97594L14.2352 12.2332L14.1013 12.375ZM8.90269 6.59925L11.0391 8.856L10.9046 8.99775L8.76825 6.741L8.90269 6.59925ZM11.952 9.28125L12.0864 9.1395L14.4911 6.59925L14.625 6.741L12.2203 9.28125L12.0864 9.423L11.8311 9.693L11.6966 9.83475L9.2925 12.375L9.15862 12.2332L11.5633 9.693L11.6972 9.55125L11.952 9.28125ZM11.6966 8.72775L14.1019 6.1875L14.2358 6.32925L11.8311 8.8695L11.6972 9.01125L11.4418 9.28125L11.3074 9.423L8.90325 11.9632L8.76881 11.8215L11.1735 9.28125L11.3074 9.1395L11.5633 8.8695L11.6966 8.72775Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphtx);
export default __webpack_public_path__ + "static/media/sphtx.1a381c4f2d086e88185b73314cef9a33.svg";
export { ForwardRef as ReactComponent };